import React, { useState } from 'react';
import { Bookmark, Trash2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { formatDate } from '@/lib/utils';
import { Button } from '@/components/ui/button';

export function ConversationListItem({
  conversation,
  onClick,
  isActive = false,
  showProjectName = true,
  onToggleSaved,
  onDelete,
}) {
  const { id, projectName, lastMessage, timestamp, is_saved } = conversation;
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick(id);
    }
  };

  const handleToggleSaved = (e) => {
    e.stopPropagation();
    if (onToggleSaved) onToggleSaved(id, !is_saved);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (confirmDelete) {
      if (onDelete) onDelete(id);
      setConfirmDelete(false);
    } else {
      setConfirmDelete(true);
      setTimeout(() => setConfirmDelete(false), 3000);
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
      className={cn(
        'group w-full text-left p-4 rounded-xl transition-all duration-200 flex items-start gap-3',
        'hover:bg-white/10 cursor-pointer',
        isActive ? 'glass-subtle' : 'bg-transparent'
      )}
    >
      <div className="flex-1 min-w-0 space-y-1.5">
        {showProjectName && (
          <div className="font-medium text-sm text-foreground">
            {projectName}
          </div>
        )}
        <div className="text-sm text-muted-foreground line-clamp-2">
          {lastMessage}
        </div>
        <div className="text-xs text-muted-foreground/70">
          {formatDate(timestamp)}
        </div>
      </div>

      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
        <Button
          variant="ghost"
          size="sm"
          className={cn("h-7 w-7 p-0", is_saved && "opacity-100 text-yellow-500")}
          onClick={handleToggleSaved}
          title={is_saved ? 'Remove bookmark' : 'Bookmark'}
        >
          <Bookmark className={cn("w-3.5 h-3.5", is_saved && "fill-current")} />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className={cn("h-7 w-7 p-0", confirmDelete && "text-red-500 opacity-100")}
          onClick={handleDelete}
          title={confirmDelete ? 'Click again to confirm' : 'Delete'}
        >
          <Trash2 className="w-3.5 h-3.5" />
        </Button>
      </div>
    </div>
  );
}
